function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, '')
}

export function getLocaleStaticJsHost(staticJsHost: string, locale?: string) {
  const normalizedStaticJsHost = trimTrailingSlash(staticJsHost)

  if (!locale) {
    return normalizedStaticJsHost
  }

  return `${normalizedStaticJsHost}/${locale}`
}
